<div class="milestone-summary-item" [class.editing]="isEditing" (click)="onItemClick()">
  <app-project-config-node
    [itemNumber]="itemNumber"
    [value]="milestone.name"
    [placeholder]="'Milestone Name'"
    [isEditing]="isEditing"
    [(selected)]="isSelected"
    [allowEdit]="true"
    [allowDelete]="true"
    [color]="'var(--color-milestone)'"
    [validationCallback]="validationCallback"
    [displayTemplate]="displayTemplate"
    [editTemplate]="editTemplate"
    (onSave)="handleSave()"
    (onCancel)="onCancel.emit()"
    (onDelete)="onDelete.emit()"
    (onStartEdit)="onEditing()"
    (hovering)="hovering.emit($event)"
  >
    <!-- Display Template -->
    <ng-template #displayTemplate>
      <div class="milestone-display">
        <span class="milestone-name">{{ itemNumber }}. {{ milestone.name }}</span>
        <span><span i18n="@@weighting">Weighting</span>: {{ milestone.weight }}</span>
      </div>
    </ng-template>

    <!-- Edit Template -->
    <ng-template #editTemplate>
      <div class="milestone-edit-container">
        <div class="edit-form">
          <div class="name-field">
            <dx-text-box
              [(value)]="editData.name"
              i18n-placeholder="@@name"
              placeholder="Name"
              valueChangeEvent="input"
              class="gpd-input"
              validationMessageMode="always"
              [maxLength]="100"
            >
              <dx-validator>
                <dxi-validation-rule type="required" i18n-message="@@nameRequired" message="Name is required" />
                <dxi-validation-rule
                  type="custom"
                  [reevaluate]="true"
                  [validationCallback]="uniqueNameValidationCallback"
                  i18n-message="@@nameAlreadyExists"
                  message="Name already Exists"
                />
              </dx-validator>
            </dx-text-box>
          </div>
          <div class="weighting-field">
            <div><span i18n="@@weighting">Weighting</span>:</div>
            <dx-number-box
              [(value)]="editData.weight"
              [min]="0"
              [max]="100"
              class="gpd-input"
              validationMessageMode="always"
            >
              <dx-validator>
                <dxi-validation-rule type="required" i18n-message="@@required" message="Required" />
                <dxi-validation-rule
                  type="range"
                  [min]="0"
                  [max]="100"
                  i18n-message="@@milestoneConfigWeightingInvalidRange"
                  message="Weighting must be between 0 and 100"
                />
              </dx-validator>
            </dx-number-box>
          </div>
        </div>
      </div>
    </ng-template>
  </app-project-config-node>
</div>
